module.exports = __webpack_public_path__ + "img/rspca-nsw.b9f36d1.png";